/**
 * Conversation chat feature flags.
 * Flip to `true` when backend APIs become available.
 *
 * @see src/api/docs/backendGap.md
 */
export const CHAT_FEATURES = {
  /** Message reactions — no Conversation reaction endpoint yet. */
  REACTIONS_ENABLED: false,
  /**
   * Gallery / camera / document / GIF send from Conversation chat.
   * SendMessage accepts attachments only with a remote `fileUrl`;
   * no Conversation media-upload endpoint exists yet.
   */
  MEDIA_UPLOAD_ENABLED: false,
} as const;

/** Minimum other participants required to create a group conversation. */
export const MIN_GROUP_CHAT_MEMBERS = 2;

/** Maximum participants for a group conversation (backend Initiate limit). */
export const MAX_GROUP_CHAT_MEMBERS = 8;
